export const PATHS = {
  IMPACTS: 'impacts',
  ACCOUNT: 'account',
  JOURNEY: 'journey',
}
